import PropTypes from "prop-types";
import React from "react";
import {FieldWrapper, FieldLabel, FieldValue} from "./WizardSummaryFieldStyle";

const WizardSummaryField = (props) => {
    const {label, value, multipleValues, dangerousHtml, valueVariant} = props;

    let fieldValue = '';
    if (value) {
        fieldValue = value;
    } else if (multipleValues && multipleValues.length > 0) {
        fieldValue = multipleValues.map(val => {
            return val.props.children
        });
    } else {
        fieldValue = '-';
    }

    return (
        <FieldWrapper>
            <FieldLabel>
                {label}
            </FieldLabel>
            <FieldValue className={valueVariant ? valueVariant : ''}>
                {
                    dangerousHtml ?
                        <span dangerouslySetInnerHTML={{__html: fieldValue}}/>
                        :
                        typeof value==="function" ? value(): fieldValue.toString()
                }
            </FieldValue>
        </FieldWrapper>
    )
};

export default WizardSummaryField;

WizardSummaryField.propTypes = {
    label: PropTypes.any.isRequired
};
